module.exports = __webpack_public_path__ + "static/media/therapies-to-avoid-blue.501b3f37.svg";